<template>
  <div class="user-list" :style="`height: ${computedHeight}px; background-color: ${isDarkMode ? '#0b1630' : '#F8F8FA'}`" id="userlist">
    <div class="w-full pr-5 text-xs flex items-center gap-x-3 flex-row justify-center py-3">
      <v-text-field placeholder="Search Email or User Name" variant="outlined" density="compact" v-model="searchName" rounded="0">
      </v-text-field>
    </div>
    <div
      v-for="user in (users.filter(u => [u.email, u.name].join(',').toLowerCase().includes(searchName.toLowerCase())))"
      :key="user.id"
      class="flex flex-row h-[55px] relative items-center justify-between p-2 listitem"
      :class="{ selected: user.user_id === selectedUserId }"
    >
      <div
      class="flex flex-row w-full h-[55px] items-center justify-between p-2 pr-10 listitem break-all text-sm"
        @click="selectUser(user)">
        <!-- red: never had a licence or a completed top-up -->
        <span class="flex flex-wrap items-center gap-x-2 min-w-0">
          <span :class="user.has_history === false ? 'text-red-500 font-semibold' : ''"
            :title="user.has_history === false ? 'New customer: never had a licence or a top-up' : ''">{{ user.name }} ({{ user.email }})</span>
          <!-- signed up from the same IP as other accounts (details in the chat) -->
          <span v-if="user.linked_count > 0" class="linked-badge" :title="'Signed up from the same IP as ' + user.linked_count + ' other account' + (user.linked_count === 1 ? '' : 's')">Same IP ×{{ user.linked_count }}</span>
        </span>
        <span v-if="user.unreadCount" class=" z-10 text-[12px] w-[25px] min-w-[25px] badge rounded-pill flex bg-danger items-center justify-center aspect-square ">{{user.unreadCount}}</span>
      </div>
      <!-- shortcut: Licences page filtered to this customer (add a test, extend, view) -->
      <v-icon v-if="!user.unreadCount" @click.stop="openLicenses(user)" class="absolute right-[18px]" icon="mdi-plus-circle-outline"
        title="Open this customer's licences / add a test" style="cursor: pointer;"></v-icon>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, defineProps, onMounted, onBeforeUnmount } from "vue";
import { storeToRefs } from "pinia";
import { useDarkModeStore } from "@/stores";
import { useRouter } from "vue-router";
const darkStore = useDarkModeStore();
const {isDarkMode} = storeToRefs(darkStore);
defineProps({
  users: Array
});
const searchName = ref("")
const emit = defineEmits(['selectUser', 'unRead']);
const selectedUserId = ref(null);
const offsetHeight = 250; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const router = useRouter();
// opens in a new tab so the conversation stays open here
const openLicenses = (user) => { if (user?.email) window.open(router.resolve({ path: "/admin/license", query: { email: user.email } }).href, "_blank", "noopener") };

const handleResize = () => {
  computedHeight.value = window.innerHeight - offsetHeight;
};
onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});
const selectUser = (user) => {
  selectedUserId.value = user.user_id;
  emit('selectUser', user);
};
</script>

<style scoped>
.user-list {
  width: 380px;
  min-width: 380px;
  border-right: 1px solid #ccc;
  overflow-y: auto;
  
}

.user-list .listitem {
  cursor: pointer;
  padding: 5px 0;
}

.user-list .listitem:hover {
  background: #b4b4b4;
}

.user-list .selected {
  background: #cfcfcf; /* Or any color you prefer for the selected background */
  color: #fff; /* Optional: Change text color for better contrast */
}


@media only screen and (max-width: 500px) {
  .user-list {
    position: absolute;
    left: -380px; /* Hidden initially off-screen */
    transition: left 0.3s ease;
    z-index: 100;
  }
  .uservisible {
    left: 0; /* Slide in from left to right */
  }
  .userhidden {
    left: -380px; /* Slide out to right to left */
  }  
}

/* phone: the list is the whole screen; ChatContent shows either the list or the conversation */
@media only screen and (max-width: 767px) {
  .user-list {
    position: static !important;
    left: 0 !important;
    width: 100% !important;
    min-width: 0 !important;
    border-right: 0;
    max-height: calc(100vh - 300px);
  }
}
</style>

<style scoped>
.linked-badge { flex: none; padding: 1px 8px; border: 1px solid var(--ui-warn); border-radius: 999px; background: var(--ui-warn-soft); color: var(--ui-warn-ink); font-size: 11px; font-weight: 700; line-height: 1.5; white-space: nowrap; }
</style>
